import { render, staticRenderFns } from "./appealDetail.vue?vue&type=template&id=55f854de&scoped=true&"
import script from "./appealDetail.vue?vue&type=script&lang=js&"
export * from "./appealDetail.vue?vue&type=script&lang=js&"
import style0 from "./appealDetail.vue?vue&type=style&index=0&id=55f854de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f854de",
  null
  
)

export default component.exports